export default __webpack_public_path__ + "static/media/no_profile.cdc6e6b8.png";